// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"a0702c81","228":"7dbc782b","333":"3d075e88","365":"dbed4a8b","517":"f0b21027","738":"5ac29ff5","957":"5248043a"}[chunkId] + ".chunk.js";
};